import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/auth/Login";
import LogOut from "../pages/auth/LogOut";
import ItemList from "../pages/items/ItemList.js";
import ItemRequests from "../pages/items/itemsRequest/ItemsRequest";
import Warehouse from "../pages/groupData/warehouse/Warehouse";
import RoleList from "../pages/roles/roleList/RoleList";
import MeasurableAssetList from "../pages/assets/MeasurableAssetList";
import NonMeasurableAssetList from "../pages/assets/NonMeasurableAssetList";
import SiteList from "../pages/groupData/sites/SiteListing";
import AssetMatrixList from "../pages/resources/assetMatrix/AssetMatrixList";
//import AssetHistoryList from "../pages/assets/AssetHistoryList";
import ServiceChecksheetHistoryList from "../pages/assets/assetHistory/ServiceChecksheetHistoryList";
import ScsExecutionHistoryList from "../pages/transactions/scsExecutionHistory/ScsExecutionHistoryList";
import FeedInList from "../pages/assets/assetHistory/FeedInList";
import AssetActivityList from "../pages/assets/assetHistory/AssetActivityList";
import AssetActivityTransactionListing from "../pages/transactions/assetActivity/AssetActivityTransactionListing";
import InvoiceCalculationList from "../pages/transactions/invoiceCalculation/InvoiceCalculationList";
import OverTimeRuleAdd from "../pages/resources/OverTimeRule/OverTimeRuleList";
import InventoryAssetList from "../pages/assets/inventoryAsset/InventoryAssetList";
import InventoryAssetView from "../pages/assets/inventoryAsset/inventoryAssetView";
import SiteTransactionList from "../pages/mobilization/siteTransition/siteTransition";

import reportRoutes from "./reportRoutes";
import AssetCounterLog from "../pages/assets/AssetCounterLog";
import MeasurableAsset from "../pages/assets/measurableAsset/MeasurableAsset";
import Configuration from "../pages/settings/configuration/Configuration";
import PurchaseList from "../pages/inventory/purchase/PurchaseList";
import ConsumptionList from "../pages/inventory/consumption/ConsumptionList";
import InventoryTransferList from "../pages/inventory/inventoryTransfer/InventoryTransferList";
import InventoryTransferAdd from "../pages/inventory/inventoryTransfer/InventoryTransferAdd";
import ScrapItemList from "../pages/inventory/scrapItem/ScrapItemList";
import ItemVoucherList from "../pages/inventory/itemVoucher/itemVocherList";
import ItemwiseScrapList from "../pages/inventory/itemwiseScrap/ItemwiseScrapList";
import TicketTransactionList from "../pages/transactions/ticketTransaction/TicketTransactionList";
import WalletList from "../pages/groupData/wallet/walletList";
import CompositeExpenseList from "../pages/transactions/compositeExpense/CompositeExpenseList";
import FundTransferAdd from "../pages/transactions/fundTransfer/FundTransferAdd";
import FundTransferList from "../pages/transactions/fundTransfer/FundTransferList";
import OpeningBalanceList from "../pages/settings/itemOpeningBalance/OpeningBalanceList";
import ConfigurationInvenotry from "../pages/settings/configurationInventory/ConfigurationInvenotry";
import VendorList from "../pages/groupData/vendor/VendorList";
import AccessDenied from "../pages/includes/ui/AccessDenied";

import Testing from "../pages/Testing";
import RequistionList from "../pages/inventory/requisition/RequistionList";
import PurchaseOrderList from "../pages/inventory/purchaseOrder/PurchaseOrderList";
import ItemAdd from "../pages/items/itemsAdd/ItemAdd";
import OpeningBalanceAdd from "../pages/settings/itemOpeningBalance/OpeningBalanceAdd";
import PurchaseAdd from "../pages/inventory/purchase/PurchaseAdd";
import ConsumptionAdd from "../pages/inventory/consumption/ConsumptionAdd";
import WarehouseAdd from "../pages/groupData/warehouse/WarehouseAdd";
import VendorAdd from "../pages/groupData/vendor/VendorAdd";
import TicketTransactionAdd from "../pages/transactions/ticketTransaction/TicketTransactionAdd";
import walletAdd from "../pages/groupData/wallet/walletAdd";
import PurchaseConsumptionEdit from "../pages/inventory/purchase/PurchaseConsumptionEdit";

import WeeklyCounterlogList from "../pages/assets/weeklyCounterlog/weeklyCounterlogList";
import RequistionAdd from "../pages/inventory/requisition/RequistionAdd";
import ConfigurationGeneral from "../pages/settings/configurationGeneral/ConfigurationGeneral";
import RequisitionEdit from "../pages/inventory/requisition/RequisitionEdit";
import PurchaseOrderAdd from "../pages/inventory/purchaseOrder/PurchaseOrderAdd";

import VendorDirectoryList from "../pages/vendorDirectory/VendorDirectoryList";
import ServiceChecksheetRunningStatus from "../pages/assets/action/serviceChecksheet/runningStatus/RunningStatus";
import AssetLogsheet from "../pages/assets/AssetLogsheet";
import ServiceChecksheetSettings from "../pages/assets/action/serviceChecksheet/Settings";
import SettingsEdit from "../pages/assets/action/serviceChecksheet/SettingsEdit";
import TicketList from "../pages/assets/history/TicketList";
import InvoiceCalculation from "../pages/assets/history/InvoiceCalculation";
import ExecutionHistory from "../pages/assets/history/ExecutionHistory";
import AssetMatrixView from "../pages/resources/assetMatrix/assetMatrixView/AssetMatrixView";
import InvoiceRuleList from "../pages/resources/InvoiceRule/InvoiceRuleList";
import InvoiceRuleAdd from "../pages/resources/InvoiceRule/InvoiceRuleAdd";
import InvoiceAssetLinking from "../pages/resources/InvoiceAssetLinking/InvoiceAssetLinking";
import Logsheet from "../pages/assets/counterlog/logsheet/Logsheet";
import DailyCounterlog from "../pages/assets/counterlog/dailyCounterlog/DailyCounterlog";
import Expense from "../pages/accounts/Expense";
import FuelFeedInList from "../pages/transactions/fuelFeedIn/FuelFeedInList";
import ProductivityList from "../pages/transactions/productivity/ProductivityList";
import CounterlogHistoryList from "../pages/transactions/counterlogHistory/CounterlogHistoryList";
import DowntimeList from "../pages/transactions/downtime/DowntimeList";
import AssetSettings from "../pages/assets/assetSettings/AssetSettings";
import RentalTransaction from "../pages/assets/history/RentalTransaction";
import FuelStationList from "../pages/groupData/fuelStation/FuelStationList";
import RosterSetting from "../pages/resources/RosterSetting";
import AssetRosterListing from "../pages/resources/AssetRosterListing";
import SiteTransitionList from "../pages/assets/assetSettings/SiteTransitionList";
import FuelStationAdd from "../pages/groupData/fuelStation/FuelStationAdd";
import FuelReceive from "../pages/groupData/fuelStation/FuelReceive";
import FuelIssued from "../pages/groupData/fuelStation/FuelIssued";
import FuelTransfer from "../pages/groupData/fuelStation/FuelTransfer";
import UserList from "../pages/groupData/users/UserList";
import UserAdd from "../pages/groupData/users/UserAdd";
import ExpenseHistory from "../pages/assets/history/ExpenseHistory";
import Employee from "../pages/hrm/employee/Employee";
import EmployeeAsset from "../pages/hrm/EmployeeAsset";
import AllocationList from "../pages/inventory/allocation/AllocationList";
import AllocationAdd from "../pages/inventory/allocation/AllocationAdd";
import AssetActivity from "../pages/assets/history/AssetActivity";
import AssetProductivity from "../pages/assets/history/AssetProductivity";
// import ItemDemandList from '../pages/assets/history/itemDemand/ItemDemandList';
// import ItemDemandAdd from '../pages/assets/history/itemDemand/ItemDemandAdd';
import DocumentList from "../pages/groupData/document/DocumentList";
import WarehouseIndentList from "../pages/inventory/warehouseIndent/WarehouseIndentList";
import WarehouseIndentAdd from "../pages/inventory/warehouseIndent/WarehouseIndentAdd";
import IndentFulfillment from "../pages/inventory/warehouseIndent/IndentFulfillment";
import NotificationList from "../pages/settings/notification/NotificationList";
import MyNotification from "../pages/settings/notification/MyNotification";
import FuelFeedIn from "../pages/assets/history/FuelFeedIn";
import AssetConsumption from "../pages/assets/history/AssetConsumption";
import AssetMatrixSearch from "../pages/assets/addAsset/AssetMatrixSearch";
import AssetAdd from "../pages/assets/addAsset/AssetAdd";
import HelpTutorialList from "../pages/settings/helpTutorial/HelpTutorialList";
import AssetTaskList from "../pages/transactions/assetTask/AssetTaskList";
import AssetTask from "../pages/assets/history/AssetTask";
import AssetAllocation from "../pages/assets/history/AssetAllocation";
import AssetSalesOrder from "../pages/assets/history/SalesOrder";
import WorkstationList from "../pages/groupData/workstation/WorkstationList";
import WorkstationAdd from "../pages/groupData/workstation/WorkstationAdd";
import EmployeeAdd from "../pages/hrm/employee/EmployeeAdd";
import RoleListing from "../pages/roles/RoleListing";
import AddRole from "../pages/roles/addRole/AddRole";
import purchaseReturnAdd from "../pages/inventory/purchaseReturn/purchaseReturnAdd";
import TicketsBoardManagement from "../pages/transactions/ticketTransaction/TicketsBoardManagement";
import ScheduleTrainingListing from "../pages/support/Training/ScheduleTrainingListing";
import ReleasesList from "../pages/dashboard/releases/ReleasesList";
import InventoryAdjustmentList from "../pages/inventory/inventoryAdjustment/InventoryAdjustmentList";
import InventoryAdjustmentAdd from "../pages/inventory/inventoryAdjustment/InventoryAdjustmentAdd";
import MyDashboard from "../pages/dashboard/MyDashboard";
import SiteProductivityConfiguration from "../pages/siteProductivity/configuration/SiteProductivityConfiguration";
import ConfigurationAdd from "../pages/siteProductivity/configuration/ConfigurationAdd";
import SiteProductivityListing from "../pages/siteProductivity/SiteProductivityListing";
import SiteProductivityAdd from "../pages/siteProductivity/SiteProductivityAdd";
import EmployeeRosterLinking from "../pages/resources/employeeRosterLinking/EmployeeRosterLinking";
import MasterDataIntegration from "../pages/custom/hgInfra/MasterDataIntegration";
import IntegrationLog from "../pages/custom/hgInfra/IntegrationLog.js";
import IOTProviderVendor from "../pages/serviceProviders/IOTProviderVendor";
import IntegrateVendor from "../pages/serviceProviders/IntegrateVendor.js";
import PurchaseReturnList from "../pages/inventory/purchaseReturn/PurchaseReturnList.js";
import SupplierVendorList from "../pages/integration/supplierVendor/SupplierVendorList.js";
import CustomerList from "../pages/groupData/customer/CustomerList.js";
import CustomerAdd from "../pages/groupData/customer/CustomerAdd.js";
import LogisticList from "../pages/inventory/logistic/LogisticList.js";
import LogisticAdd from "../pages/inventory/logistic/LogisticAdd.js";
import Downtime from "../pages/assets/history/Downtime.js";
import SubAssemblyList from "../pages/groupData/subAssembly/SubAssemblyList.js";
import AddSubAssembly from "../pages/groupData/subAssembly/AddSubAssembly.js";
import ProjectStructure from "../pages/projectManagement/ProjectStructure.js";
import Project from "../pages/projectManagement/Project.js";
import ProjectDetail from "../pages/projectManagement/ProjectDetail.js";
import EngagementTimeList from "../pages/transactions/engagementTime/EngagementTimeList.js";
import ConfigurationHrm from "../pages/settings/configurationHrm/ConfigurationHrm.js";
import ItemDemandList from "../pages/inventory/itemDemand/ItemDemandList.js";
import ItemDemandAdd from "../pages/inventory/itemDemand/ItemDemandAdd.js";
import AssetDemand from "../pages/assets/history/AssetDemand.js";

import ConfigurationSales from "../pages/settings/configurationSales/ConfigurationSales.js";
import QuotationList from "../pages/salesCrm/quotation/QuotationList.js";
import QuotationAdd from "../pages/salesCrm/quotation/QuotationAdd.js";
import DealsTransactionAdd from "../pages/salesCrm/dealsTransaction/DealsTransactionAdd.js";
import DealsTransactionList from "../pages/salesCrm/dealsTransaction/DealsTransactionList.js";
import CustomerProjectList from "../pages/salesCrm/customerProject/CustomerProjectList.js"
import CustomerProjectAdd from "../pages/salesCrm/customerProject/CustomerProjectAdd.js";
import DealsBoardManagement from "../pages/salesCrm/dealsTransaction/DealsBoardManagement.js";
import Compliance from "../pages/resources/assetMatrix/assetMatrixView/compliance/Compliance.js";
import AdditionalAttributeHistory from "../pages/assets/history/AdditionalAttributeHistory.js";
import SalesOrderList from "../pages/salesCrm/salesOrder/SalesOrderList.js";
import SalesOrderAdd from "../pages/salesCrm/salesOrder/SalesOrderAdd.js";
import SalesAllocationList from "../pages/salesCrm/salesAllocation/SalesAllocationList.js";
import SalesAllocationAdd from "../pages/salesCrm/salesAllocation/SalesAllocationAdd.js";
import DailyAttendance from "../pages/hrm/attendance/DailyAttendance.js";
import EmployeeAttendenceDetail from "../pages/hrm/attendence1/EmployeeAttendenceDetail.js";
import SalesInvoiceList from "../pages/salesCrm/salesInvoice/SalesInvoiceList.js";
import SalesInvoiceAdd from "../pages/salesCrm/salesInvoice/SalesInvoiceAdd.js";
import SiteProductivityData from "../pages/siteProductivity/SiteProductivityData.js";
import AssetProductivityReport from "../pages/assetProductivity/AssetProductivityReport.js";
import AssetConfigurationAdd from "../pages/assetProductivity/AssetConfigurationAdd.js";
import NewSiteProdAdd from "../pages/siteProductivity/NewSiteProdAdd.js";
import MyProfile from "../pages/includes/MyProfile.js";
import EmailLogList from "../pages/resources/EmailLogsList.js";
import StartProject from "../pages/projectManagement/StartProject.js";
import ProjectEdit from "../pages/projectManagement/ProjectEdit.js";
import NotificationLogList from "../pages/resources/NotificationLogList.js";
import ActivityCalendar from "../pages/reports/ActivityCalender/ActivityCalender.js";
import WorklogList from "../pages/hrm/worklog/WorklogList.js";
import QRCodePrinter from "../pages/items/QRCodePrinter.js";
import QRCodeLabelPrinter from "../pages/items/QRCodeLabelPrinter.js";
import PassCodeList from "../pages/settings/passcode/PassCodeList.js";
import PasscodeAdd from "../pages/settings/passcode/PasscodeAdd.js";
import PasscodeLogList from "../pages/resources/PasscodeLogList.js";

export default [

    { path: "/assets/activity/:id", exact: !1, name: "Activity List", component: AssetActivity, subModule: "Asset Activity" , permission : "iam-asset-activity-view"  },
    { path: "/assets/fuelfeedin/:id", exact: !1, name: "Fuel FeedIn", component: FuelFeedIn, subModule: "feedin",   },
    { path: "/assets/task/:id", exact: !1, name: "Task List", component: AssetTask, subModule: "iam-task-workflow" ,  },
    { path: "/assets/productivity/:id", exact: !1, name: "Productivity List", component: AssetProductivity, subModule: "Productivity",  permission : "iam-asset-productivity-view"  },


    { path: "/assets/invoice_calculation/:id", exact: !1, name: "Invoice Calcualtion", component: InvoiceCalculation, subModule: "iam-asset-invoice",  permission : "iam-asset-invoice-view"  },


    { path: "/assets/service_checksheet/:id", exact: !0, name: "Service Checksheet Running Status", component: ServiceChecksheetRunningStatus, subModule: "iam-asset-scs",  permission : "iam-asset-scs-view"  },
    { path: "/assets/settings/:id", exact: !1, name: "Service Checksheet Settings", component: ServiceChecksheetSettings, subModule: "iam-asset-scs",  permission : "iam-asset-scs-view"  },
    

    { path: "/assets/ticket/:id", exact: !1, name: "Ticket", component: TicketList, subModule: "iam-ticket" ,},
    
    
    { path: "/assets/consumption/:id", exact: !1, name: "Consumption List", component: AssetConsumption, subModule: "consumption",  permission : "isc-consumption-view"  },
    { path: "/assets/sales_order/:id", exact: !1, name: "Asset Sales Order List", component: AssetSalesOrder, subModule: "sales_order", permission : "sales_order_view"  },

    { path: "/dashboard",                       exact: !0,  name: "Dashboard",              component: Dashboard,               subModule: "" },
    { path: "/new_releases",                    exact: !0,  name: "New Releases",           component: ReleasesList,            subModule: "" },
    { path: "/help/:id",                        exact: !0,  name: "Help Tutorial",          component: HelpTutorialList,        subModule: "" },

    { path: "/measurable_asset",                exact: !0,  name: "Measurable Asset List",  component: MeasurableAssetList ,     subModule: "asset",             },
    { path: "/asset/:tab/:id",                  exact: !1,  name: "Asset",                  component: MeasurableAsset,         subModule: "asset",   },
    { path: "/non_measurable_asset",            exact: !0,  name: "NonMeasurableAsset",     component: NonMeasurableAssetList,  subModule: "asset",   },
    { path: "/assets/setting/edit/:id/:scs_id", exact: !1,  name: "Service Settings Edit",  component: SettingsEdit,            subModule: "asset",  permission : "iam-asset-scs-view"  },
    { path: "/assets/additional_attribute",     exact: !1,  name: "Ticket",                 component: AdditionalAttributeHistory,subModule: "asset",   },

    { path: "/assets/logsheets/:id",            exact: !0,  name: "Asset Logsheets",        component: AssetLogsheet,           subModule: "counterlog" ,   },
    { path: "/assets/logsheet/:id",             exact: !0,  name: "Asset Logsheet",         component: Logsheet,                subModule: "counterlog",    },

    { path: "/general_configuration/:config",   exact: !0,  name: "General Inventory",      component: ConfigurationGeneral,    subModule: "",                  permission: "group-configuration" },
    { path: "/configuration/:config",           exact: !0,  name: "MasterDataNew",          component: Configuration,           subModule: "configuration",     permission: "iam-configuration" },
    { path: "/inventory_configuration/:config", exact: !0,  name: "Inventory Inventory",    component: ConfigurationInvenotry,  subModule: "isc-configuration", permission: "isc-configuration" },
    { path: "/hrm_configuration/:config",       exact: !0,  name: "HRM",                    component: ConfigurationHrm,        subModule: "hrm-employee",      permission: "hrm-configuration" },
    { path: '/sales_configuration/:config',     exact: !0,  name: "Sales Configuration",    component: ConfigurationSales,      subModule: "scrm-configuration",permission: "scrm-configuration"},

    { path: "/roles",                           exact: !0,  name: "Roles",                  component: RoleListing,             subModule: "role-permission",   permission:"iam-user-role-view"},
    {  path: "/passcode/:id?", exact: !0, name: "Passcode", component: PassCodeList, subModule: "", permission: "" },
    { path: "/passcode_add", exact: !0, name: "Passcode Add", component: PasscodeAdd, subModule: "", permission: "" },
     { path: "/passcode_edit/:id?", exact: !0, name: "Passcode Add", component: PasscodeAdd, subModule: "", permission: "" },


    { path: "/project_structure",               exact: !0,  name: "Project Structure",      component: ProjectStructure,        subModule: "iam-project-management",permission:"iam-project-template-view"},
    { path: "/project",                         exact: !0,  name: "Project Config",         component: Project,                 subModule: "iam-project-management",permission:"iam-project-view"},
    { path: "/project/:id?",                     exact: !0,  name: "Project Detail",         component: ProjectDetail,           subModule: "iam-project-management",permission:"iam-project-view"},
    { path: "/project_add",                     exact: !0,  name: "Project Config",         component: StartProject, 
                        subModule: "iam-project-management",permission:"iam-project-view"},
    {
        path: "/project_edit/:id?", exact: !0, name: "Project Config", component: ProjectEdit,
        subModule: "iam-project-management", permission: "iam-project-view"
    },

    
    { path: "/assets/allocation/:id", exact: !1, name: "Allocation List", component: AssetAllocation, subModule: "allocation",  permission: "isc-allocation-view" },
    { path: "/assets/demand/:id", exact: !1, name: "Item Demand List", component: AssetDemand, subModule: "isc_item_demand" ,  permission: "isc_item_demand_view"},
    { path: "/assets/execution_history/:id", exact: !1, name: "Execution History", component: ExecutionHistory, subModule: "" },
    { path: "/item_list", exact: !0, name: "ItemList", component: ItemList, subModule: "isc-item",  permission: "isc-item-view" },
    { path: "/item_list/:tab/:id", exact: !0, name: "Item List", component: ItemList, subModule: "isc-item",  permission: "isc-item-view" },
    { path: "/requisition_list", exact: !0, name: "RequisitionList", component: RequistionList, subModule: "purchase-requisition",  permission: "isc-purchase-requisition-view" },
    { path: "/warehouse", exact: !0, name: "Warehouse", component: Warehouse, subModule: "" },
    { path: "/warehouse/add", exact: !0, name: "Warehouse", component: WarehouseAdd, subModule: "" },
    { path: "/warehouse/update", exact: !1, name: "Warehouse Update", component: WarehouseAdd, subModule: "" },
    { path: "/purchase_list", exact: !0, name: "Purchase", component: PurchaseList, subModule: "purchase" ,  permission: "isc-purchase-view"},
    { path: "/purchase_list/add", exact: !1, name: "Purchase", component: PurchaseAdd, subModule: "purchase" ,  permission: "isc-purchase-view"},
    { path: "/purchase_list/update", exact: !1, name: "Purchase Update", component: PurchaseAdd, subModule: "purchase",  permission: "isc-purchase-view" },
    { path: "/purchase_list/update_with_consumption", exact: !1, name: "Purchase Update", component: PurchaseConsumptionEdit, subModule: "purchase" ,  permission: "isc-purchase-view"},
    { path: "/purchase_list/:id?", exact: !1, name: "Purchase", component: PurchaseList, subModule: "purchase" ,  permission: "isc-purchase-view"},
    { path: "/vendor", exact: !0, name: "Vendor", component: VendorList, subModule: "vendor",  permission: "vendor-view" },
    { path: "/vendor/add", exact: !1, name: "Vendor Add", component: VendorAdd, subModule: "vendor",  permission: "vendor-view" },
    { path: "/vendor/update", exact: !1, name: "Vendor Update", component: VendorAdd, subModule: "vendor",  permission: "vendor-view" },
    { path: "/consumption_list", exact: !0, name: "Consumption", component: ConsumptionList, subModule: "consumption",  permission: "isc-consumption-view" },
    { path: "/consumption_list/add", exact: !1, name: "Consumption Add", component: ConsumptionAdd, subModule: "consumption",  permission: "isc-consumption-view"},
    { path: "/consumption_list/update", exact: !1, name: "Consumption Update", component: ConsumptionAdd, subModule: "consumption",  permission: "isc-consumption-view" },
    { path: "/inventory_transfer_list", exact: !0, name: "Inventory", component: InventoryTransferList, subModule: "inventory-transfer",  permission: "isc-inventory_transfer-view" },
    { path: "/inventory_transfer_list/add", exact: !0, name: "Inventory Transfer Add", component: InventoryTransferAdd, subModule: "inventory-transfer",  permission: "isc-inventory_transfer-view" },



    { path: "/scrap_item_list", exact: !0, name: "Scrap Item", component: ScrapItemList, subModule: ""},
    { path: "/item_voucher_list", exact: !0, name: "Item Voucher", component: ItemVoucherList, subModule: "isc-item"},
    { path: "/itemwise_scrap_list", exact: !0, name: "Itemwise Scrap", component: ItemwiseScrapList, subModule: "" },
    { path: "/item_request", exact: !0, name: "ItemRequest", component: ItemRequests, subModule: "isc-item" ,},



   
    { path: "/sites", exact: !0, name: "Sites", component: SiteList, subModule: "site" },
    { path: "/asset_matrix", exact: !0, name: "Asset Matrix", component: AssetMatrixList, subModule: ""},
    { path: "/service_checksheet_history", exact: !0, name: "Service Checksheet History", component: ServiceChecksheetHistoryList, subModule: "iam-asset-scs",permission: "iam-asset-scs-view" },
    { path: "/service_checksheet_execution_history", exact: !0, name: "Service Checksheet Execution History", component: ScsExecutionHistoryList, subModule: "iam-asset-scs" ,permission: "iam-asset-scs-view"},
    { path: "/feedin_list", exact: !0, name: "Fuel FeedIn", component: FeedInList, subModule: "feedin" ,},
    { path: "/fuel_feedin_list", exact: !0, name: "Fuel FeedIn", component: FuelFeedInList, subModule: "feedin" ,},


    { path: "/ticket", exact: !0, name: "Ticket List", component: TicketTransactionList, subModule: "iam-ticket" },
    { path: "/project_ticket", exact: !0, name: "Ticket List", component: TicketTransactionList, subModule: "" },
    { path: "/ticket/add", exact: !1, name: "Ticket Add", component: TicketTransactionAdd, subModule: "iam-ticket" },

    
    { path: "/asset_activity", exact: !0, name: "Asset Activity", component: AssetActivityList, subModule: "Asset Activity" },
    { path: "/asset_activity_transaction", exact: !0, name: "Asset Activity", component: AssetActivityTransactionListing, subModule: "Asset Activity" },
    { path: "/invoice_calculation_list", exact: !0, name: "Invoice Calculation List", component: InvoiceCalculationList, subModule: "iam-asset-invoice" },


    { path: "/ot_rule_list", exact: !0, name: "Overtime Rule List", component: OverTimeRuleAdd, subModule: ""},

    { path: "/inventory_asset_list", exact: !0, name: "inventory Asset List", component: InventoryAssetList, subModule: "iam-inventory-asset" },
    { path: "/inventory_asset_view", exact: !0, name: "inventory Asset View", component: InventoryAssetView, subModule: "iam-inventory-asset" },
    { path: "/site_transaction_history", exact: !0, name: "Site Transition History", component: SiteTransactionList, subModule: "site" },





    { path: "/asset_counterlog", exact: !0, name: "Asset CounterLog", component: AssetCounterLog, subModule: "counterlog"},
    { path: "/wallet", exact: !0, name: "Wallet", component: WalletList, subModule: "Wallet",  },
    { path: "/wallet/add", exact: !1, name: "Wallet Add", component: walletAdd, subModule: "Wallet" , },
    { path: "/wallet/update", exact: !1, name: "Wallet Update", component: walletAdd, subModule: "Wallet" , },
    { path: "/wallet/fund-transfer/:id", exact: !1, name: "Fund Transfer", component: FundTransferAdd, subModule: "" , },
    { path: "/wallet/fund-transfer", exact: !1, name: "Fund Transfer", component: FundTransferAdd, subModule: "" , },



    { path: "/fund_transfer", exact: !0, name: "Fund Transfer", component: FundTransferList, subModule: "" },
    { path: "/composite_expense", exact: !0, name: "Composite Expense", component: CompositeExpenseList, subModule: "expense" },
    { path: "/item_opening_balance", exact: !0, name: "Inventory Opening Balance", component: OpeningBalanceList, subModule: "" },
    { path: "/item_opening_balance/add", exact: !0, name: "Add Opening Balance", component: OpeningBalanceAdd, subModule: "" },
    { path: "/item_opening_balance/update", exact: !1, name: "Opening Balance", component: OpeningBalanceAdd, subModule: "" },
    { path: "/access_denied/:page", exact: !0, name: "Access Denied", component: AccessDenied, subModule: "" },




    { path: "/purchase_order_list", exact: !0, name: "Purchase ORder", component: PurchaseOrderList, subModule: "purchase-order" },
    { path: "/purchase_order/add", exact: !0, name: "Purchase Order Add", component: PurchaseOrderAdd, subModule: "purchase-order" },
    { path: "/purchase_order_list/:transaction_id", exact: !1, name: "Purchase ORder Detail", component: PurchaseOrderList, subModule: "purchase-order" },


    { path: "/item_list/add_item", exact: !1, name: "Item Add", component: ItemAdd, subModule: "isc-item" , permission :"isc-item-view"},
    { path: "/item_list/update_item", exact: !1, name: "Item Add", component: ItemAdd, subModule: "isc-item" , permission :"isc-item-view"},
    { path: "/weekly_counterlog", exact: !0, name: "Weekly Counterlog", component: WeeklyCounterlogList, subModule: "counterlog" },
    { path: "/daily_counterlog", exact: !0, name: "Daily Counterlog", component: DailyCounterlog, subModule: "counterlog" },




    { path: "/requisition_list/add", exact: !0, name: "Requisition Add", component: RequistionAdd, subModule: "purchase-requisition" , permission :"isc-purchase-requisition-view"},
    { path: "/requisition_list/edit", exact: !0, name: "Requisition Update", component: RequisitionEdit, subModule: "purchase-requisition" , permission :"isc-purchase-requisition-view"},

    { path: "/vendor_directory_list", exact: !0, name: "Vendor Directory List", component: VendorDirectoryList, subModule: "vendor" , permission :"vendor-view"},

    { path: "/asset_matrix/:tab/:id", exact: !0, name: "Asset Matrix View", component: AssetMatrixView, subModule: ""},
    { path: "/asset_matrix/compliance", exact: !0, name: "Asset Matrix View", component: Compliance, subModule: "iam-compliance"},
    { path: "/invoice_rule", exact: !0, name: "Invoice Rule", component: InvoiceRuleList, subModule: "iam-asset-invoice" , permission :"iam-asset-invoice-view"},
    { path: "/invoice_rule_add", exact: !0, name: "Invoice Rule Add", component: InvoiceRuleAdd, subModule: "iam-asset-invoice" , permission :"iam-asset-invoice-view"},
    { path: "/asset-invoice-rules", exact: !0, name: "Asset Invoice Rule Linking", component: InvoiceAssetLinking, subModule: "iam-asset-invoice" , permission :"iam-asset-invoice-view"},


    { path: "/expense_list/:id?", exact: !0, name: "Expense List", component: Expense, subModule: "expense"},



    { path: "/productivity_list", exact: !0, name: "Productivity List", component: ProductivityList, subModule: "Productivity" ,},
    { path: "/asset_productivity_list", exact: !0, name: "Productivity List", component: ProductivityList, subModule: "Productivity", permission :"iam-asset-productivity-view" },
    { path: "/counterlog_history_list", exact: !0, name: "Counterlog History List", component: CounterlogHistoryList, subModule: "counterlog" , },
    { path: "/assets/counterlog/:id", exact: !0, name: "Counterlog History List", component: CounterlogHistoryList, subModule: "counterlog" },



    { path: "/downtime_list", exact: !0, name: "Downtime List", component: DowntimeList, subModule: "Downtime" ,permission :"downtime-view"},
    { path: "/assets/asset_setting/:id", exact: !0, name: "Asset Settings", component: AssetSettings, subModule: ""},
    { path: "/assets/rental_transaction/:id", exact: !0, name: "Rental Transaction", component: RentalTransaction, subModule: "iam-rental"},


    { path: "/fuelstation_list", exact: !0, name: "Fuel Station List", component: FuelStationList, subModule: "fuelstation", },
    { path: "/fuelstation_add", exact: !0, name: "Fuel Station Add", component: FuelStationAdd, subModule: "fuelstation", },


    { path: "/roster_list", exact: !0, name: "Roster List", component: RosterSetting, subModule: "" ,},
    { path: "/asset_roster_list", exact: !0, name: "Asset Roster List", component: AssetRosterListing, subModule: "", },


    { path: "/assets/site_transition/:id", exact: !0, name: "Site Transititon", component: SiteTransitionList, subModule: "site"},
    { path: "/fuel_station/recieve/:id", exact: !0, name: "Fuel Receive", component: FuelReceive, subModule: "fuel"},
    { path: "/fuel_station/issued/:id", exact: !0, name: "Fuel Issued", component: FuelIssued, subModule: "fuel" },
    { path: "/fuel_station/fuel_transfer/:id", exact: !0, name: "Fuel Transfer", component: FuelTransfer, subModule: "fuel" },




    { path: "/user_list", exact: !0, name: "User List", component: UserList, subModule: "user",permission :"grp-user-view" },
    { path: "/user_add", exact: !0, name: "User Add", component: UserAdd, subModule: "user",permission :"grp-user-view" },


    { path: "/assets/expense_history/:id", exact: !0, name: "Expense History", component: ExpenseHistory, subModule: "expense" },


    { path: "/employee_list/:id?", exact: !0, name: "Employee List", component: Employee, subModule: "hrm-employee",permission :"hrm-employee-view" },
    { path: "/employee_list/compliance/:id?", exact: !0, name: "Employee List", component: Employee, subModule: "hrm-employee",permission :"hrm-employee-view" },
    { path: "/employee_asset_list", exact: !0, name: "Employee Asset List", component: EmployeeAsset, subModule: "hrm-employee",permission :"hrm-employee-view" },



    { path: "/allocation_list", exact: !0, name: "Allocation List", component: AllocationList, subModule: "allocation" ,permission :"isc-allocation-view"},
    { path: "/allocation_list/add", exact: !0, name: "Allocation Add", component: AllocationAdd, subModule: "allocation" ,permission :"isc-allocation-view"},

    { path: "/warehouse_indent_list", exact: !0, name: "Warehouse Indent", component: WarehouseIndentList, subModule: "warehouse-indent" ,permission :"isc-warehouse-indent-view"},


    { path: "/document_list", exact: !0, name: "Document List", component: DocumentList, subModule: ""},

    { path: "/warehouse_indent_add", exact: !0, name: "Warehouse Indent Add", component: WarehouseIndentAdd, subModule: "warehouse-indent" ,permission :"isc-warehouse-indent-view"},
    { path: "/indent_fulfillment", exact: !0, name: "Indent Fulfillment", component: IndentFulfillment, subModule: ""},


    { path: "/group_notification_list", exact: !0, name: "Group Notification", component: NotificationList, subModule: "Group" ,permission :"iam-notification-setting-view"},
    { path: "/notification_setting", exact: !0, name: "Notification Setting", component: MyNotification, subModule: "notification-setting",permission :"iam-notification-setting-view" },


    { path: "/asset_matrix/add_asset", exact: !0, name: "Asset Matrix Search", component: AssetMatrixSearch, subModule: ""},


    { path: "/add_asset/:id", exact: !0, name: "Asset Add", component: AssetAdd, subModule: ""},




    { path: "/task_transaction_list", exact: !0, name: "Task List", component: AssetTaskList, subModule: "iam-task-workflow"},




    { path: "/workstation_list", exact: !0, name: "Workstation List", component: WorkstationList, subModule: ""},
    { path: "/workstation_add", exact: !0, name: "Workstation Add", component: WorkstationAdd, subModule: "" },


    { path: "/employee_add", exact: !0, name: "Employee Add", component: EmployeeAdd, subModule: "hrm-employee" ,permission :"hrm-employee-view"},
    { path: "/add_role", exact: !0, name: "Role Add", component: AddRole, subModule: "role-permission" ,permission :"iam-user-role-view"},



    { path: "/inventory_adjustment_list", exact: !0, name: "Inventory Adjustment List", component: InventoryAdjustmentList, subModule: "isc-inventory-adjustment",permission :"isc-inventory-adjustment-view" },

    { path: "/inventory_adjustment_add", exact: !0, name: "Inventory Adjustment Add", component: InventoryAdjustmentAdd, subModule: "isc-inventory-adjustment" ,permission :"isc-inventory-adjustment-view"},

    { path: "/asset_productivity_configuration/:id?", exact: !0, name: "Asset Productivity Configuration", component: AssetProductivityReport, subModule: "Productivity" ,permission :"iam-asset-productivity-view"},
    { path: "/asset_productivity_configuration_add", exact: !0, name: "Asset Productivity Configuration Add", component: AssetConfigurationAdd, subModule: "Productivity",permission :"iam-asset-productivity-view" },
    { path: "/site_productivity_configuration/:id?", exact: !0, name: "Site Productivity Configuration", component: SiteProductivityConfiguration, subModule: "iam-site-productivity",permission :"site-productivity-configuration-view" },
    { path: "/site_productivity_configuration_add", exact: !0, name: "Site Productivity Configuration Add", component: ConfigurationAdd, subModule: "iam-site-productivity" ,permission :"site-productivity-configuration-view"},
    { path: "/site_productivity", exact: !0, name: "Site Productivity List", component: SiteProductivityData, subModule: "iam-site-productivity" ,permission :"site-productivity-view"},
    { path: "/site_productivity/add", exact: !0, name: "Site Productivity Add", component: SiteProductivityAdd, subModule: "iam-site-productivity" ,permission :"site-productivity-view"},
    { path: "/site_productivity/multiple_add", exact: !0, name: "Site Productivity Add", component: NewSiteProdAdd, subModule: "iam-site-productivity" ,permission :"site-productivity-view"},





    { path: "/employee_roster_linking", exact: !0, name: "Employee Roster Linking", component: EmployeeRosterLinking, subModule: "hrm-employee"},

    
    { path: "/master_data_integration", exact: !0, name: "Master Data Integration", component: MasterDataIntegration, subModule: ""},
    { path: "/master_data_integration_log", exact: !0, name: "Master Data Integration Log", component: IntegrationLog, subModule: "" },
    { path: "/purchase_return_add", exact: !0, name: "Add Purchase Return", component: purchaseReturnAdd, subModule: "purchase-return" ,permission :"isc-purchase-return-view"},
    { path: "/purchase_return_list", exact: !0, name: "Purchase Return List", component: PurchaseReturnList, subModule: "purchase-return" ,permission :"isc-purchase-return-view"},


    { path: "/supplier_vendor_list", exact: !0, name: "Supplier Vendor List", component: SupplierVendorList, subModule: "vendor" ,permission :"vendor-view"},
    { path: "/assets/downtime/:id", exact: !0, name: "Donwtime List", component: Downtime, subModule: "Downtime" ,permission :"downtime-view"},



    { path: "/report/ticket_board_list", exact: !0, name: "Ticket", component: TicketsBoardManagement, subModule: "" },
    { path: "/training_list", exact: !0, name: "Training List", component: ScheduleTrainingListing, subModule: "" },
    { path: "/my_dashboard", exact: !0, name: "My Dashboard", component: MyDashboard, subModule: ""},


    { path: "/iot_integration", exact: !0, name: "IOT Integration", component: IOTProviderVendor, subModule: ""},
    { path: "/iot_integration/:vender/:id", exact: !0, name: "IOT Integration Vender", component: IntegrateVendor, subModule: "" },



    { path: "/customer_list", exact: !0, name: "Customer List", component: CustomerList, subModule: "" },
    { path: "/customer/add", exact: !1, name: "Customer Add", component: CustomerAdd, subModule: "" },
    { path: "/customer/update", exact: !1, name: "Customer Update", component: CustomerAdd, subModule: "" },
    { path: "/logistic_list", exact: !0, name: "Logistic", component: LogisticList, subModule: "isc_logistic" ,permission :"logistic_view"},
    { path: "/logistic_add", exact: !1, name: "Logistic", component: LogisticAdd, subModule: "isc_logistic" ,permission :"logistic_view"},



    { path: "/engagement_time_list", exact: !1, name: "Engagement Time", component: EngagementTimeList, subModule: "iam-engagement-time"},


    { path: "/item_demand_list", exact: !1, name: "Item Demand List", component: ItemDemandList, subModule: "isc_item_demand" ,permission :"isc_item_demand_view"},
    { path: "/item_demand_add", exact: !1, name: "Item Demand Add", component: ItemDemandAdd, subModule: "isc_item_demand",permission :"isc_item_demand_view" },


    { path: "/sub_assembly/:id?", exact: !0, name: "Sub Assembly", component: SubAssemblyList, subModule: "" },
    { path: "/sub_assembly_add", exact: !0, name: "Sub Assembly Add", component: AddSubAssembly, subModule: "" },
    { path: "/sub_assembly_update", exact: !0, name: "Sub Assembly Update", component: AddSubAssembly, subModule: "" },




   





    { path: '/quotation_list', exact: !0, name: "Quotation List", component: QuotationList, subModule: "quotation" ,permission :"quotation-view"},
    { path: '/quotation_add', exact: !0, name: "Quotation Add", component: QuotationAdd, subModule: "quotation",permission :"quotation-view" },

    { path: '/deals/add', exact: !1, name: "Deals Add", component: DealsTransactionAdd, subModule: "deals" },
    { path: '/deals', exact: !0, name: "Deals List", component: DealsTransactionList, subModule: "deals" },
    { path: '/deals/:transaction_id', exact: !1, name: "Deal Details", component: DealsTransactionList, subModule: "deals" },
    

    { path: '/customer_project_list', exact: !1, name: "Customer Project List", component: CustomerProjectList, subModule: "customer_project" ,permission :"customer-project-view"},
    { path: '/customer_project_add', exact: !1, name: "Customer Project Add", component: CustomerProjectAdd, subModule: "customer_project" ,permission :"customer-project-view"},


    { path: "/report/deal_board_list", exact: !0, name: "Ticket", component: DealsBoardManagement, subModule: ""},

    { path: "/testing", exact: !0, name: "Testing", component: Testing, subModule: "" },
    { path: '/sales_order_list', exact: !0, name: "Sales Order List", component: SalesOrderList, subModule: "sales_order" ,permission :"sales_order_view"},
    { path: '/sales_order_list/:transaction_id', exact: !1, name: "Sales Order Detail", component: SalesOrderList, subModule: "sales_order" ,permission :"sales_order_view"},
    { path: '/sales_order_add', exact: !0, name: "Sales Order Add", component: SalesOrderAdd, subModule: "sales_order" ,permission :"sales_order_view"},
    { path: '/sales_allocation_list', exact: !0, name: "Sales Allocation List", component: SalesAllocationList, subModule: "scrm-sales-allocation" ,permission :"scrm-sales-allocation-view"},
    { path: "/sales_allocation_add", exact: !0, name: "Sales Allocation Add", component: SalesAllocationAdd, subModule: "scrm-sales-allocation",permission :"scrm-sales-allocation-view" },
    { path: '/sales_invoice', exact: !0, name: "Sales Invoice", component: SalesInvoiceList, subModule: "scrm-sales-invoice",permission :"scrm-sales-invoice-view" },
    { path: '/sales_invoice_add', exact: !0, name: "Sales Invoice Add", component: SalesInvoiceAdd, subModule: "scrm-sales-invoice" ,permission :"scrm-sales-invoice-view"},
    { path: "/email_logs", exact: !0, name: "Email Logs", component: EmailLogList, subModule: "" ,},
    { path: "/notification_logs", exact: !0, name: "Notification Logs", component: NotificationLogList, subModule: "" ,},
    { path: "/passcode_logs", exact: !0, name: "Passcode Logs", component: PasscodeLogList, subModule: "" ,},


    // { path: "/qr_test", exact: !0, name: "Print QR", component: QRCodePrinter, subModule: "" ,},
    { path: "/qr_test", exact: !0, name: "Print QR", component: QRCodeLabelPrinter, subModule: "" ,},

    



    { path: '/hrm/daily_attendance', exact: !0, name: "Employee Daily Attendence", component: DailyAttendance, subModule: "hrm_employee_attendance",permission :"hrm-employee-view" },
    { path: "/employee_daily_attendence/:id", exact: !0, name: "Employee Daily Attendence Detail", component: EmployeeAttendenceDetail, subModule: "hrm_employee_attendance", permission: "hrm-employee-view" },
    { path: "/activity_calender", exact: !0, name: "Activity Calender", component: ActivityCalendar, subModule: "", },
    { path: "/worklog_list", exact: !0, name: "Worklog", component: WorklogList, subModule: "", },



    { path: "/my_profile", exact: !0, name: "MyProfile", component: MyProfile, subModule: "" },
    { path: "/", exact: !0, name: "Login", component: Login, subModule: "" },
    { path: "/logout", exact: !0, name: "LoginOut", component: LogOut, subModule: "" },






    ...reportRoutes,
];
